import { Clipboard } from '@angular/cdk/clipboard'
import { computed, Directive, inject, input } from '@angular/core'

/**
 * Kopiert beim Klick auf den Knopf zur DHL-Zweitzustellung die Sendungsnummer. Vorausfuellen laesst
 * sich das Formular nicht: `dhl.de/nochmal-zustellen` liest weder Sendungsnummer noch PLZ aus dem
 * Link (Widget-Code nachgesehen 2026-10-26). Kopiert wird die 20-stellige Nummer, nicht die PLZ:
 * die fuenf Ziffern tippt man ab, die Nummer nicht. Ohne Nummer (oder bei mehreren, DHL nimmt je
 * Auftrag eine) bleibt die Zwischenablage unberuehrt. `hinweis()` ist der passende Tooltip-Satz.
 */
@Directive({
  selector: '[libSendungsnummerKopieren]',
  exportAs: 'libSendungsnummerKopieren',
  host: { '(click)': 'kopieren()' },
})
export class SendungsnummerKopierenDirective {
  private readonly clipboard = inject(Clipboard)

  readonly sendungsnummer = input<string | null | undefined>(undefined, { alias: 'libSendungsnummerKopieren' })

  readonly hinweis = computed(() => (this.sendungsnummer() ? 'Kopiert dabei die Sendungsnummer' : ''))

  protected kopieren() {
    const sendungsnummer = this.sendungsnummer()
    if (sendungsnummer) {
      this.clipboard.copy(sendungsnummer)
    }
  }
}
